import type { SearchQuery } from '../hooks/useProvidedJobPosts';

/**
 * 求人検索クエリに「何らかの絞り込み条件」が適用されているかを判定する。
 *
 * 並び順 (sort) や検索カラム・演算子のデフォルト値は絞り込みとして扱わない。
 * 主に「全件選択」ボタンを検索適用時のみ表示する判定に使う。
 */
export default function hasActiveFilter(sq: SearchQuery): boolean {
  if (sq.company_ids?.length) return true;
  if (sq.custom_tag_ids?.length) return true;
  if (sq.list_ids?.length) return true;
  if (sq.status?.length) return true;
  if (sq.job_position_name?.trim()) return true;
  if (sq.prefecture_codes?.length) return true;
  if (sq.min_salary?.trim()) return true;
  if (sq.max_salary?.trim()) return true;
  if (sq.salary?.trim()) return true;
  if (sq.search_keyword_alpha?.trim()) return true;
  if (sq.search_keyword_beta?.trim()) return true;
  if (sq.search_keyword_gamma?.trim()) return true;
  if (sq.is_include_archived) return true;
  if (sq.is_salary_empty) return true;
  if (sq.is_available !== undefined) return true;
  if (sq.job_source_id !== undefined) return true;
  if (sq.created_type) return true;
  return false;
}
